import { BrowserRouter, Routes, Route } from "react-router-dom";
import LenisScroll from "./components/LenisScroll";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Services from "./components/Services";
import Contact from "./components/Contact";
import WhyUs from "./components/WhyUs";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import Admin from "./pages/Admin";

function Home() {
  return (
    <LenisScroll>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <WhyUs />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </LenisScroll>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
